import { programCertificateTierLabel } from '@/utils/programCertificateTier';

const LETTER = /^[A-Z]$/;

/**
 * Localized label for ``ProgramAccreditationLevel`` tier codes (roman I–IV or classification letters).
 */
export function programAccreditationLevelLabel(
  code: string | undefined | null,
  t: (key: string, ...args: unknown[]) => string
): string {
  const c = (code || '').trim().toUpperCase();
  if (!c) return '';
  if (['I', 'II', 'III', 'IV'].includes(c)) {
    return programCertificateTierLabel(c, (key) => t(key));
  }
  if (LETTER.test(c)) {
    return t('programAccreditationClassification', { letter: c });
  }
  return c;
}
